import { Grid2, InputLabel, styled } from '@mui/material';

export const Container = ({ children, ...props }) => {
    return (
        <Grid2 container width="100%" direction="column" justifyContent="flex-start" alignItems="flex-start" gap="4px" {...props}>
            {children}
        </Grid2>
    );
};

export const Label = styled(InputLabel)({
    fontSize: '18px',
    fontWeight: 400,
    color: '#131313',
});

export const PRICE_TYPE = {
    INHERIT: 1,
    FIXED: 2,
    PRICE_GROUP: 3,
};

export const TAB_FORMS = {
    DETAILS: 0,
    UNITS: 1,
};
